export const newPageNotificationModal = {
	title: "Tudo em um só lugar!",
	content:
		"Repensamos essa tela para você criar e gerenciar seus produtos com mais praticidade e organização. Explore o novo fluxo no seu ritmo.",
	primaryActionLabel: "Ver novidades",
};
